import { InjectionToken, InputSignal, Type } from '@angular/core';
import { AppConfigModel } from '@libs/cms/models';

export interface CepHostSlotComponent {
  config: InputSignal<AppConfigModel>;
}

export interface CepHostSlots {
  header?: Type<CepHostSlotComponent>;
  footer?: Type<CepHostSlotComponent>;
}

export interface CepHostOptions {
  showMobileBottomNavigation?: boolean;
}

export const CEP_HOST_SLOTS: InjectionToken<CepHostSlots> =
  new InjectionToken<CepHostSlots>('CEP host slots');

export const CEP_HOST_OPTIONS: InjectionToken<CepHostOptions> =
  new InjectionToken<CepHostOptions>('CEP host options');
